module.exports = __webpack_public_path__ + "static/media/fiske.9c18957e.svg";